import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTramite } from "../context/Tramite";
import "./css/components.css";
import { useCatalog } from "../context/Catalog";
import {
  buscarUnidad,
  listarDestinosResiduosTratamiento,
  listarFrecuenciasRetiros,
} from "../api/General";
import { crearResiduoTratamiento, withResiduosPeligrosos } from "../utils/data";
import { isInvalid } from "../utils/forms";
import { isEditable } from "../utils/tramite";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import ArrayField from "./controls/ArrayField";
import Label from "./controls/Label";
import { ResiduoTratamientoForm } from "./ResiduoTratamientoForm";
import { ResiduoTratamientoList } from "./ResiduoTratamientoList";
import { TipoTramite } from "../utils/enums";

export default function ResiduosTratamientoForm({ ...props }) {
  const { tramite } = useTramite();
  const { t } = useTranslation();
  const tramiteForm = useFormikContext();
  const unidadCantidadCatalog = useCatalog(["unidad", "M3ANIO"], () =>
    buscarUnidad("M3ANIO"),
  );
  const frecuenciasRetirosCatalog = useCatalog(
    ["frecuenciasRetiros"],
    () => listarFrecuenciasRetiros(null),
  );
  const destinosResiduosCatalog = useCatalog(
    ["destinosResiduosTratamiento"],
    () => listarDestinosResiduosTratamiento(null),
  );
  const loading =
    unidadCantidadCatalog.loading ||
    frecuenciasRetirosCatalog.loading ||
    destinosResiduosCatalog.loading;
  const handleResiduosTratamientoChange = (event) => {
    tramiteForm.handleChange(event);
  };
  useEffect(() => {
    if (
      !tramiteForm.values.conResiduosPeligrosos &&
      tramiteForm.values.tipo?.codigo === TipoTramite.DJG
    ) {
      const conPeligrosidad =
        tramiteForm.values.residuosTratamiento?.filter(
          (residuoTratamiento) => residuoTratamiento.conPeligrosidad,
        ).length > 0;
      if (conPeligrosidad) {
        withResiduosPeligrosos(tramiteForm, true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tramiteForm.values.residuosTratamiento]);
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col lg={12}>
            <ArrayField
              id="residuosTratamiento"
              name="residuosTratamiento"
              value={tramiteForm.values?.residuosTratamiento}
              onChange={handleResiduosTratamientoChange}
              createItem={crearResiduoTratamiento}
              isInvalid={isInvalid("residuosTratamiento", tramiteForm)}
              error={
                (tramiteForm.errors.residuosTratamiento instanceof Array &&
                  t("errors.tramite.residuosTratamiento.many")) ||
                t(tramiteForm.errors.residuosTratamiento)
              }
              disabled={!isEditable(tramite)}
            >
              {({
                value: residuosTratamiento,
                append,
                remove,
                replace,
                select,
                selectedIndex,
                selectedItem,
                disabled,
              }) => (
                <Grid>
                  {!disabled && (
                    <Row>
                      <Col>
                        <ResiduoTratamientoForm
                          value={selectedItem}
                          page={selectedIndex}
                          pages={residuosTratamiento.length}
                          select={select}
                          append={append}
                          replace={replace}
                          remove={remove}
                          tramiteForm={tramiteForm}
                          unidadCantidad={unidadCantidadCatalog.data}
                          destinosResiduosTratamiento={
                            destinosResiduosCatalog.data
                          }
                          frecuenciasRetiros={frecuenciasRetirosCatalog.data}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  )}

                  <Row>
                    <Col>
                      <Label>{t("tramite.residuosTratamiento")}</Label>
                      <ResiduoTratamientoList
                        value={residuosTratamiento}
                        select={select}
                        remove={remove}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ArrayField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
